import { render } from "./InterfaceTabHeader.vue?vue&type=template&id=3898b8a3&scoped=true"
import script from "./InterfaceTabHeader.vue?vue&type=script&lang=js"
export * from "./InterfaceTabHeader.vue?vue&type=script&lang=js"

import "./InterfaceTabHeader.vue?vue&type=style&index=0&id=3898b8a3&scoped=true&lang=scss"

import exportComponent from "/var/www/blocks/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3898b8a3"]])

export default __exports__